import { faCheck, faSignInAlt, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import { NavLink, useNavigate } from 'react-router-dom';
import { PasswordResetForm } from '../../Auth/Components/PasswordResetForm';
import { useAuth } from '../../../Contexts/AuthProvider';
import { usePasswordReset } from '../../Auth/Hooks/usePasswordReset';

/**
 * Login page under the home section.
 */
export const ResetPassword = () => {
  const navigate = useNavigate();
  const { loginWithTokens } = useAuth();

  const { handleSubmit, error } = usePasswordReset({
    onSuccess: (response) => {
      loginWithTokens({ accessToken: response.access_token, expiry: response.expiry }).then(
        (user) => {
          navigate('/agent');
        }
      );
    },
  });

  return (
    <>
      <Helmet>
        <title>Log In</title>
      </Helmet>
      <div className="intro mb-5">
        <Container className="max-w-xl pt-5 pb-5">
          <Row className="pt-2 mt-5">
            <Col lg={5}>
              <h1 className="fw-bold mt-4 text-white">Password reset</h1>
              <p className="text-white lead">
                Enter your username and we will send you an email to reset your password.
              </p>
            </Col>
            <Col lg={7}>
              <Card className="border bg-white">
                <div className="card-icon">
                  <FontAwesomeIcon icon={faSignInAlt} />
                </div>
                <Card.Body className="p-4">
                  <PasswordResetForm onSubmit={handleSubmit} errorMessage={error ?? undefined} />
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};
